import { defineMessages } from 'react-intl';

export const playerMessages = defineMessages({
    'player.backward_15': {
        id: 'player.backward_15',
        defaultMessage: 'Skip backward 15 seconds',
        description:
            'Alt text for the button to go back 15 seconds in the player.',
    },
    'player.current_time': {
        id: 'player.current_time',
        defaultMessage: 'Current Time: {time}',
        description: 'The current time of the content in the player.',
    },
    'player.autoplay_error.top_label': {
        id: 'player.autoplay_error.top_label',
        defaultMessage: 'Autoplay session paused',
        description: 'Autoplay error tooltip label.',
    },
    'player.autoplay_error.content': {
        id: 'player.autoplay_error.content',
        defaultMessage: 'Click play to continue',
        description: 'Autoplay error tooltip message.',
    },
    'player.disable_cc': {
        id: 'player.disable_cc',
        defaultMessage: 'Disable Closed Captioning',
        description: 'Button to disable closed captioning in the player.',
    },
    'player.duration': {
        id: 'player.duration',
        defaultMessage: 'Duration: {time}',
        description: 'The total length of the content in the player.',
    },
    'player.enable_cc': {
        id: 'player.enable_cc',
        defaultMessage: 'Enable Closed Captioning',
        description: 'Button to enable closed captioning in the player.',
    },
    'player.forward_15': {
        id: 'player.forward_15',
        defaultMessage: 'Skip forward 15 seconds',
        description:
            'Alt text for the button to go forward 15 seconds in the player.',
    },
    'player.previous_track': {
        id: 'player.previous_track',
        defaultMessage: 'Play previous track',
        description: 'Button to play the previous track in the player.',
    },
    'player.next_track': {
        id: 'player.next_track',
        defaultMessage: 'Play next track',
        description: 'Button to play the next track in the player.',
    },
    'player.mute': {
        id: 'player.mute',
        defaultMessage: 'Mute Audio',
        description: 'Button to mute the audio in the player.',
    },
    'player.unmute': {
        id: 'player.unmute',
        defaultMessage: 'Unmute Audio',
        description: 'Button to unmute the audio in the player.',
    },
    'player.pause': {
        id: 'player.pause',
        defaultMessage: 'Pause',
        description: 'Button to pause the content in player.',
    },
    'player.play': {
        id: 'player.play',
        defaultMessage: 'Play',
        description: 'Button to play the content in player.',
    },
    'player.replay': {
        id: 'player.replay',
        defaultMessage: 'Replay',
        description: 'Button to replay the content in player.',
    },
    'player.seek_slider': {
        id: 'player.seek_slider',
        defaultMessage: 'Seek Slider',
        description:
            'Alt text for the seek slider in the player, to select a specific point in time in the content.',
    },
    'player.toggle_fullscreen': {
        id: 'player.toggle_fullscreen',
        defaultMessage: 'Toggle Fullscreen',
        description: 'Button to toggle fullscreen mode in the player.',
    },
    'player.skip': {
        id: 'player.skip',
        defaultMessage: 'Skip',
        description: 'Button to skip the content in the player.',
    },
    'player.minimize': {
        id: 'player.minimize',
        defaultMessage: 'Minimize Player',
        description: 'Button to minimize the player.',
    },
    'player.expand': {
        id: 'player.expand',
        defaultMessage: 'Expand Player',
        description: 'Button to expand the player.',
    },
    'player.stop': {
        id: 'player.stop',
        defaultMessage: 'Stop',
        description: 'Button to stop the content in the player.',
    },
});

export default playerMessages;
